import React from 'react';
import Img from 'gatsby-image';
import './FullScreenImage.scss';

type FullScreenImageProps = {
    sizes: any;
    alt?: string;
};

const imgStyle = {
    width: '100%',
    height: '100%',
};

const FullScreenImage = ({ sizes, alt }: FullScreenImageProps) => {
    return <Img className="FullScreenImage" sizes={sizes} alt={alt || ''} style={imgStyle} />;
};

export { FullScreenImage, FullScreenImageProps };
